import * as Yup from 'yup';

export const CreateCarrierSchema = Yup.object({
  name: Yup.string().trim().required('Carrier name is required'),
  logo: Yup.mixed()
    .test('logo-required', 'Logo is required', value => {
      return typeof value === 'string' || (value && typeof value === 'object');
    })
    .required('Logo is required'),
  d365AccountDisplayValue: Yup.string().optional(),
  code: Yup.string().when('isAccountHolder', {
    is: true,
    then: schema => schema.trim().required('Code is required for account holder'),
    otherwise: schema => schema.optional(),
  }),

  vendorLocationMap: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .optional()
          .test('name-required-if-locationId', 'Name is required when Location ID is provided', function (value) {
            const { locationId } = this.parent;
            if (locationId && locationId.trim() !== '') {
              return !!(value && value.trim() !== '');
            }
            return true;
          }),
        locationId: Yup.string()
          .optional()
          .test('locationId-required-if-name', 'Location ID is required when Name is provided', function (value) {
            const { name } = this.parent;
            if (name && name.trim() !== '') {
              return !!(value && value.trim() !== '');
            }
            return true;
          }),
      }),
    )
    .optional()
    .test('vendorLocationMap-validation', 'Both fields are required if either is filled', function (array) {
      if (!array || array.length === 0) return true;

      return array.every(item => {
        const hasName = item.name && item.name.trim() !== '';
        const hasLocationId = item.locationId && item.locationId.trim() !== '';

        if (!hasName && !hasLocationId) return true;

        return hasName && hasLocationId;
      });
    }),
});
